export default __webpack_public_path__ + "static/media/x-box-image-detail-3.8ace4f2e.png";